import styled from 'styled-components'
import { Box } from 'src/components'

interface ContentFormProps {
    width?: string
}

export const ContentForm = styled.form<ContentFormProps>`
    width: ${({ width }) => width || '80%'};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`
export const Spacing = styled(Box)``
export const ContentBottom = styled(Box)`
    height: 35px;
`
export const Button = styled.button<{ enable: boolean }>`
    cursor: ${({ enable }) => (enable ? 'not-allowe' : 'pointer')};
    background-color: ${({ theme, enable }) =>
        enable ? theme.colors.disabled : theme.colors.second};
    color: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.second};
    padding: 0 10px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    font-family: inherit;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    :hover {
        color: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.primary};
    }
    :after {
        content: '';
        background: ${({ theme }) => theme.colors.primary};
        border: 2px solid ${({ theme }) => theme.colors.primary};
        position: absolute;
        z-index: -1;
        padding: 16px 20px;
        display: block;
        border-radius: 50%;
        left: -50%;
        right: -50%;
        top: -150%;
        bottom: -150%;
        transform: scale(0, 0);
        transition: all 0.4s ease;
    }
    :hover::after {
        transition: all 0.6s ease-out;
        transform: scale(1, 1);
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        font-weight: 600;
        font-size: 13.3333px;
        line-height: 20px;
    }
`
